import './confirmModal.css';

export default function ConfirmModal({ open, title = 'Confirm', message = 'Are you sure?', onConfirm, onCancel, confirmText = 'Delete', cancelText = 'Cancel' }) {
  if (!open) return null;
  return (
    <div className="confirm-backdrop">
      <div className="confirm-dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="confirm-actions">
          <button className="ghost-btn" onClick={onCancel}>{cancelText}</button>
          <button className="danger-btn" onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}
